var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.rootComponent,{tag:"component",attrs:{"sidebar":_vm.sidebarItems,"projectHeader":_vm.projectHeader,"selectedKeys":_vm.selectedKeys,"inlineIndent":36,"verticalWidth":310},on:{"click":_vm.itemSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }